import Vue from 'vue';
import _ from 'lodash';
import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGOUT_SUCCESS,
    GET_LOGIN_CODE,
    IMG_CODE_UPDATE,
    USERNAME_UPDATE,
    SET_INFO_FROM_LOCAL,
    GET_USER_AUTH_SUCCESS,
    SET_AUTHROUTER
} from '../mutationTypes';
import {
    setLoginInfo,
    deleteLoginInfo,
    setLoginErrTimes,
    clearLoginErrTimes,
} from '../../utils/loginInfo';
import { resetRouter } from '../../router/index';

const state = {
    token: '',
    sstore: '',
    storeRegion: '',
    storeMobile: '',
    loginType: '',
    hasVipCard: 0,
    hasChargeCard: 0,
    loading: false,
    userName: '',
    code: '',
    uuid: '',
    baseUrl: '',
    loginErrTimes: 0,
    errorTip: '',
    auth: null,
    authList: [],
    hasRouter: 0
};

const mutations = {
    [LOGIN_REQUEST](state) {
        state.loading = true;
    },
    [LOGIN_SUCCESS](state, res) {
        state.loading = false;
        state.token = res.token;
        state.sstore = res.sstore;
        state.loginType = res.loginType;
        state.storeRegion = res.sstoreRegion;
        state.storeMobile = res.store_mobile;
        state.hasVipCard = res.hasVipCard || 0;
        state.hasChargeCard = res.hasChargeCard || 0;

        state.uuid = '';
        state.baseUrl = '';
        state.code = '';
    },
    [LOGIN_FAILURE](state) {
        state.loading = false;
        state.token = '';
    },
    [USERNAME_UPDATE](state, val) {
        state.userName = val;
    },
    [SET_INFO_FROM_LOCAL](state, info) {
        state.token = info.token;
        state.sstore = info.sstore;
        state.storeRegion = info.sstoreRegion;
        state.storeMobile = info.store_mobile;
        state.loginType = info.loginType;
        state.hasVipCard = info.hasVipCard || 0;
        state.hasChargeCard = info.hasChargeCard || 0;
    },
    [LOGOUT_SUCCESS](state) {
        state.token = '';
        state.sstore = '';
        state.storeRegion = '';
        state.storeMobile =  '';
        state.loginType = '';
        state.hasVipCard = 0;
        state.hasChargeCard = 0;
    },
    [GET_LOGIN_CODE](state, res) {
        state.uuid = res.id;
        state.baseUrl = res.img;
    },
    [IMG_CODE_UPDATE](state, code) {
        state.code = code;
    },
    [GET_USER_AUTH_SUCCESS](state, res) {
        state.auth = res;
        if (res.auth_ids && res.auth_ids.length) {
            state.authList = res.auth_ids.split(',');
        } else {
            state.authList = [];
        }
    },
    [SET_AUTHROUTER](state, params) {
        state.hasRouter = params;
    }
};

export const actions = {
    async userLogin({ commit }, { password, loginType }) {
        // sessionStorage
        commit(LOGIN_REQUEST);
        let params = {
            userName: state.userName,
            password,
            loginType
        };

        if (state.uuid) {
            params = _.extend(params, {
                VerificationCode: state.code,
                id: state.uuid,
            });
        }

        const res = await Vue.$ajax.post('userLogin', params);

        if (!res.errorType) {
            const resConfig = Object.assign({}, res, { loginType });
            commit(LOGIN_SUCCESS, resConfig);
            // storage
            setLoginInfo(resConfig);
            clearLoginErrTimes();
            return {
                status: true,
                needCode: false,
            };
        }
        const needCode = setLoginErrTimes();
        commit(LOGIN_FAILURE);
        return {
            status: false,
            needCode,
            errmsg: res.errmsg
        };
    },
    async getLoginCode({ commit }) {
        const res = await Vue.$ajax.post('getCode');

        if (!res.errorType) {
            commit(GET_LOGIN_CODE, res);
        }
    },
    async userLogout({ commit }) {
        await Vue.$ajax.get('userLogout');

        commit(LOGOUT_SUCCESS);
        deleteLoginInfo();
    },
    async getUserAuth({ commit }) {
        const res = await Vue.$ajax.get('userAuth');

        commit(GET_USER_AUTH_SUCCESS, res);
    },
    setRouter({ commit }, params) {
        if (params === 0) resetRouter();
        commit(SET_AUTHROUTER, params);
    }
};

// getters
const getAuthList = state => state.appInfo.authList;
const getRouterState = state => state.appInfo.hasRouter;
const getLoginType = state => state.appInfo.loginType;

export const getters = {
    getAuthList,
    getRouterState,
    getLoginType
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/appInfo.js